import { useEvento } from "@/store/evento/evento";
import { useEventoContext } from "../../contexts";
import { EntradasSeleccionadasCard } from "./EntradasSeleccionadasCard";

type Props = {
    onRemove?: (tipoEntradaId: string, seatId: string) => void;
}

export function EntradasSeleccionadas({ onRemove }: Props) {
    const { state: entradas, removeAsiento } = useEvento.use.entradas();
    const { tipos } = useEventoContext();

    // Map de tipos para acceso rápido
    const tiposMap = tipos.reduce((acc, tipo) => {
        acc[tipo.id] = tipo;
        return acc;
    }, {} as Record<string, typeof tipos[0]>);

    // Aplanar todas las entradas con sus asientos
    const entradasFlat = entradas.flatMap((entrada) =>
        entrada.asientos?.map((asiento) => ({
            tipoEntradaId: entrada.tipoEntradaId,
            seatId: asiento.seatId,
            mesaId: asiento.mesaId,
            precio: entrada.precio,
            nombre: entrada.nombre,
        })) || []
    );

    const handleRemove = (tipoEntradaId: string, seatId: string, mesaId: string) => {
        removeAsiento({
            tipoEntradaId,
            seatId,
            mesaId,
            selected: false
        });
        onRemove?.(tipoEntradaId, seatId);
    };

    if (entradasFlat.length === 0) {
        return (
            <div className="text-center py-8 text-white/60">
                <p>No hay entradas seleccionadas</p>
            </div>
        );
    }

    return (
        <div className="space-y-3">
            {entradasFlat.map((entrada, idx) => {
                const tipo = tiposMap[entrada.tipoEntradaId];
                const color = tipo?.color || '#7c3aed';

                return (
                    <EntradasSeleccionadasCard
                        key={`${entrada.tipoEntradaId}-${entrada.seatId}-${idx}`}
                        nombre={entrada.nombre}
                        mesaId={entrada.mesaId}
                        seatId={entrada.seatId}
                        precio={entrada.precio}
                        color={color}
                        onRemove={() => handleRemove(entrada.tipoEntradaId, entrada.seatId, entrada.mesaId)}
                    />
                );
            })}
        </div>
    );
};